export default __webpack_public_path__ + "static/media/property_1_4.e4207067.webp";